const lenis = new Lenis({
  inertia: 0.3,
});

lenis.on("scroll", (e) => { });

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

class Utils {
  static accordionInit(toggleEl, targetEl, duration = 300, breakpoint = 99999) {
    jQuery("body").on("click", toggleEl, (e) => {
      if (jQuery(window).width() < breakpoint) {
        jQuery(e.currentTarget).siblings(targetEl).stop().slideToggle(duration);
        jQuery(e.currentTarget).parent().toggleClass("active").siblings().removeClass("active").find(targetEl).slideUp(duration);
      }
    });
  }

  static accordionInit1(toggleEl, targetEl, duration = 300, breakpoint = 99999) {
    jQuery("body").on("click", toggleEl, (e) => {
      if (jQuery(window).width() < breakpoint) {
        jQuery(e.currentTarget).siblings(targetEl).stop().slideToggle(duration);
        jQuery(e.currentTarget).parents().siblings().find(targetEl).slideUp(duration);
        jQuery(e.currentTarget).parent().toggleClass("active").parent().siblings().find('.small-acc-item').removeClass("active");
      }
    });
  }

  static accordionInit2(toggleEl, targetEl, duration = 300, breakpoint = 99999) {
    jQuery("body").on("click", toggleEl, (e) => {
      if (jQuery(window).width() < breakpoint) {
        jQuery(e.currentTarget).siblings(targetEl).stop().slideToggle(duration);
        jQuery(e.currentTarget).parents().siblings().find(targetEl).slideUp(duration);
        jQuery(e.currentTarget).closest('.form-group').toggleClass("active").siblings('.form-group').removeClass("active");

      }
    });
  }
}

var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  wowo(jQuery);
  headerMenu();
  headerspace();
  headercart();
  htmladdClass();
  accordion();
  slider();
  getlink();
  labelup();
  copy();
  copyBtn();
  parallax();
  emailchecked();
  selfsettingheightbox();
  arrowpadding();
  clicksize();
  changeimgcol();
  filterpopbox();
  initProductCardSlider();

  // search
  jQuery("body").on("click", "header .search-action", function (e) {
    e.stopPropagation();
    jQuery('html,body').attr('data-lenis-prevent', 'true');
  });

  jQuery(".search-modal .search-modal__content predictive-search-component form .predictive-search-form__header .predictive-search__close-modal-button")
    .on("click", function (e) {
      e.stopPropagation();
      closeSearch();
    });

  jQuery("body").on("click", function (e) {
    const $target = jQuery(e.target);

    if ($target.closest("header .search-action").length) return;

    if ($target.closest(
      ".search-modal .search-modal__content predictive-search-component form"
    ).length) return;

    closeSearch();
  });

  function closeSearch() {
    jQuery('html,body').removeAttr('data-lenis-prevent');
  }

});

let scrollY = window.scrollY;

jQuery(window).scroll(function () {
  wowo(jQuery);
  parallax();

  if (jQuery(document).scrollTop() > 30) {
    jQuery('header').addClass('sticky');
  } else {
    jQuery('header').removeClass('sticky');
  }

  let currentY = window.scrollY;

  scrollY = currentY;
});

jQuery(window).on('load', function () {
  arrowpadding();
});

var resizeTimer;
jQuery(window).resize(function () {
  headerMenu();

  clearTimeout(resizeTimer);

  resizeTimer = setTimeout(function () {
    arrowpadding();
  }, 100);
});

function wowo($) {
  let wTop = $(window).scrollTop(),
    wHeight = $(window).height(),
    wBottom = wTop + wHeight;

  if ($(".ajax-listing-block").length <= 0) {
    $(".wowo:not(.animated)").each(function () {
      let me = $(this),
        meTop = me.offset().top,
        meHeight = me.innerHeight(),
        meBottom = meTop + meHeight;

      let addOffset = $(window).width() < 576 ? 0 : 50;
      let limitTop = wTop - meHeight + addOffset;
      let limitBottom = wBottom + meHeight;

      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("wowo animated");
        }, 1500);
      }
    });
  }
}

function headerMenu() {
  // Mobile
  jQuery(document).ready(function ($) {
    $(".burger-btn").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      $("html").addClass("overflow-hidden");
      $('header .mobile-navbar-menu').addClass('active');
      $("header").addClass('active');

      $("html, body")
        .attr("data-lenis-prevent", "true")
        .data("menu-lenis-added", true);
    });

    $('body').on('click', '.mobile-navbar-menu .menu-item-has-children .title-box', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).closest('.menu-item-has-children')
        .find('.sub-nav')
        .addClass('active');
      $(this).parents('nav').siblings('.mobile-sticky-bar').addClass('hide')
    });

    $(".mobile-navbar-menu .mobile-sticky-bar .back").on("click", function (e) {
      e.stopPropagation();
      $('.sub-nav').removeClass('active');
      $(this).parents('.mobile-sticky-bar').removeClass('hide');
    });

    $(".mobile-sticky-bar .close-btn").on("click", function (e) {
      e.stopPropagation();
      closeMobileMenu();
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.mobile-navbar-menu .content').length &&
        !$(e.target).closest('.burger-btn').length &&
        !$(e.target).closest('.mobile-filter-control').length) {
        closeMobileMenu();
      }
    });

    function closeMobileMenu() {
      $("html").removeClass("overflow-hidden");
      $('header .mobile-navbar-menu').removeClass('active');
      $("header").removeClass('active');
      $(".mobile-navbar-menu .sub-nav").removeClass("active");
      $(".mobile-sticky-bar").removeClass('hide');

      $('html, body').each(function () {
        const $el = $(this);
        if ($el.data("menu-lenis-added")) {
          $el.removeAttr("data-lenis-prevent");
          $el.removeData("menu-lenis-added");
        }
      });
    }

    function handleResize() {
      if ($(window).width() >= 1201) {
        closeMobileMenu();
      }
    }

    handleResize();
    $(window).on('resize', handleResize);
  });

  // PC
  jQuery("header .menu-item-has-children").on("mouseenter", function () {
    if (jQuery(window).width() >= 1201) {
      jQuery("header .menu-item-has-children").removeClass("hovered");
      jQuery("header .sub-nav").removeClass("show");

      jQuery(this).addClass("hovered");
      jQuery(this).find(".sub-nav").addClass("show");

      jQuery("header").addClass("active");
    }
  });

  jQuery("header").on("mouseleave", function () {
    if (jQuery(window).width() >= 1201) {
      jQuery("header .menu-item-has-children").removeClass("hovered");
      jQuery("header .sub-nav").removeClass("show");
      jQuery("header").removeClass("active");
    }
  });

  jQuery("header .sub-nav").on("click", function (e) {
    e.stopPropagation();
  });

  // ESC
  jQuery(document).on('keydown', function (e) {
    if (e.keyCode === 27) {
      if (jQuery('.header-menu').hasClass('active')) {
        jQuery(".header-burger").removeClass("active");
        jQuery(".header-burger").parents('.container').removeClass("active");
        jQuery('.header-menu').removeClass("active");
      }
    }
  });
}

function headerspace() {

}

function headercart() {
  var cartIconBubble = jQuery('#cart-icon-bubble');
  var cartCountBubble = cartIconBubble.find('.cart-count-bubble');

  if (cartCountBubble.length > 0) {
    cartIconBubble.addClass('newClass');
  } else {
    cartIconBubble.removeClass('newClass');
  }

  setInterval(function () {
    cartCountBubble = cartIconBubble.find('.cart-count-bubble');
    if (cartCountBubble.length > 0) {
      cartIconBubble.addClass('newClass');
    } else {
      cartIconBubble.removeClass('newClass');
    }
  }, 1000);

  if (window.location.hash === '#cart-open') {
    setTimeout(function () {
      jQuery('.cart-drawer button').trigger('click');
    }, 300);
  }
}

function htmladdClass() {
  jQuery('#cart-icon-bubble').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');

    jQuery('.header .container .header-right ul li .search-button').removeClass('is-click');
    jQuery('.header__search ').removeClass('open');
  });

  jQuery('.product-details .product-form__buttons').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');

    jQuery('.header .container .header-right ul li .search-button').removeClass('is-click');
    jQuery('.header__search ').removeClass('open');
  });

  jQuery('.media-back button').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').addClass('overflow-hidden');

    jQuery('.header .container .header-right ul li .search-button').removeClass('is-click');
    jQuery('.header__search ').removeClass('open');
  });

  jQuery('.drawer__close').on('click', function (e) {
    e.stopPropagation();
    jQuery('html').removeClass('overflow-hidden');
  });

  jQuery('.drawer__inner,.drawer__footer,cart-drawer-items').on('click', function (e) {
    e.stopPropagation();
  });

  jQuery('body').on('click', function (e) {
    jQuery('html').removeClass('overflow-hidden');
  });
}

function accordion() {
  Utils.accordionInit(".acc-head", ".acc-body");
  Utils.accordionInit1(".small-acc-head", ".small-acc-body");
  Utils.accordionInit2(".small-acc-child-head", ".small-acc-child-body");

  $("body").on("click", ".facets__item .facets__summary, .facets__item .acc-head", function (e) {
    e.preventDefault();

    $('.acc-item').removeClass('active');

    const $item = $(this).closest(".facets__item");
    const $panel = $item.find("floating-panel-component").first();

    $panel.stop(true, true).slideToggle(300);
    $item.toggleClass("open")
      .siblings(".facets__item")
      .removeClass("open")
      .find("floating-panel-component,.acc-body")
      .stop(true, true)
      .slideUp(300);
  });

}

function slider() {
  jQuery('.slider-banner .left-content .text-box').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplaySpeed: 5000,
    asNavFor: '.slider-banner .right-content .media-box'
  });

  jQuery('.slider-banner .right-content .media-box').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplaySpeed: 5000,
    asNavFor: '.slider-banner .left-content .text-box'
  });

  if (jQuery('.row-text-slider .right-content .slider-box').length > 0) {
    jQuery('.row-text-slider .right-content .slider-box').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      infinite: false,
      speed: 500,
      fade: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  if (jQuery(".marquee").length > 0) {
    Marquee3k.init({
      selector: 'marquee'
    });

    setTimeout(function () {
      $('.marquee').css('opacity', '1')
    }, 150);
  }

  wowo($);

  function debounce(func, wait = 100) {
    let timeout;
    return function () {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }

  var slickInitialized = false;
  function colfourmodel() {
    const $cardBox = jQuery('.col-four-model .content .slider-box');
    const isMobileView = jQuery(window).width() < 992;

    if ($cardBox.length > 0) {
      if (isMobileView && !slickInitialized) {
        $cardBox.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: true,
          infinite: false,
          speed: 500,
          autoplaySpeed: 8000,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 450,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
        slickInitialized = true;
      } else if (!isMobileView && slickInitialized) {
        $cardBox.slick('unslick');
        slickInitialized = false;
      }
    }
  }

  var slickInitialized1 = false;
  function fourcolcards() {
    const $cardBox = jQuery('.four-col-cards .content');
    const isMobileView = jQuery(window).width() < 992;

    if ($cardBox.length > 0) {
      if (isMobileView && !slickInitialized1) {
        $cardBox.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: true,
          infinite: false,
          speed: 500,
          autoplaySpeed: 8000,
          responsive: [
            {
              breakpoint: 450,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
        slickInitialized1 = true;
      } else if (!isMobileView && slickInitialized1) {
        $cardBox.slick('unslick');
        slickInitialized1 = false;
      }
    }
  }

  function initProductSliders() {
    const $bigSlider = jQuery('.product-banner .left-box .big-media-box');
    const $smallSlider = jQuery('.product-banner .left-box .small-media-box');

    const bigCount = $bigSlider.find('.img').length;
    const smallCount = $smallSlider.find('.img').length;

    if (bigCount === 1 && smallCount === 1) {
      $smallSlider.css('display', 'none');
      $bigSlider.css('margin', '0');
      return;
    }

    if ($bigSlider.hasClass('slick-initialized')) {
      $bigSlider.slick('unslick');
    }
    if ($smallSlider.hasClass('slick-initialized')) {
      $smallSlider.slick('unslick');
    }

    const enableDots = bigCount > 1;

    $bigSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: enableDots,
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: true,
      infinite: true,
      speed: 500,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      asNavFor: '.product-banner .left-box .small-media-box',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            dots: enableDots,
          }
        }
      ]
    });

    $smallSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      focusOnSelect: true,
      autoplay: false,
      pauseOnHover: false,
      pauseOnFocus: true,
      infinite: true,
      speed: 500,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      asNavFor: '.product-banner .left-box .big-media-box',
    });
  }

  colfourmodel();
  fourcolcards();
  initProductSliders();

  const debounceResize = debounce(() => {
    colfourmodel();
    fourcolcards();
    initProductSliders();
  }, 100);

  window.addEventListener('resize', debounceResize);
}

function initProductCardSlider() {
  const $sliders = jQuery('.product-card-slider');
  if (!$sliders.length) return;

  $sliders.each(function () {
    const $slider = jQuery(this);
    const $sliderBox = $slider.find('.slider-box');
    const isStyle2 = $slider.hasClass('style-2');

    function setupSlider() {
      const winWidth = jQuery(window).width();
      const slideCount = $sliderBox.children().length;

      if (isStyle2) {
        if (winWidth < 1201) {
          if (!$sliderBox.hasClass('slick-initialized')) {
            $sliderBox.slick({
              slidesToShow:
                winWidth < 577 ? 1 :
                  winWidth < 992 ? 2 : 3,
              slidesToScroll: 1,
              arrows: true,
              dots: false,
              autoplay: false,
              infinite: winWidth < 577 ? false : true,
              speed: 500,
              responsive: [
                {
                  breakpoint: 1201,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: true,
                  },
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: true,
                  },
                },
                {
                  breakpoint: 577,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                  },
                },
              ],
            });
          }
        } else {
          if ($sliderBox.hasClass('slick-initialized')) {
            $sliderBox.slick('unslick');
          }
        }
      } else {
        if (slideCount < 4) {
          if ($sliderBox.hasClass('slick-initialized')) {
            $sliderBox.slick('unslick');
          }
          return;
        }

        if (!$sliderBox.hasClass('slick-initialized')) {
          $sliderBox.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            infinite: true,
            speed: 500,
            fade: false,
            autoplaySpeed: 5000,
            responsive: [
              {
                breakpoint: 1201,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows: true,
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  arrows: true,
                },
              },
              {
                breakpoint: 577,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                },
              },
            ],
          });
        }
      }
    }

    setupSlider();

    let resizeTimer;

    jQuery(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setupSlider, 200);
    });
  });
}

function getlink() {
  if (jQuery('.faqs-model .right-box .content-box h2').length) {
    var count = 0;
    jQuery('.faqs-model .right-box .content-box h2').each(function () {
      let anchorText = jQuery(this).text().trim().replace(/^\d+\.\s*/, ''),
        anchorLink = anchorText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

      if (!anchorLink) {
        anchorLink = 'heading-' + count;
      }

      jQuery(this).attr('id', anchorLink);
      jQuery('.jumplinks ul').append(`<li id="jumplink-${anchorLink}"><a href="#${anchorLink}">${anchorText}</a></li>`);
      count++;
    });
  } else {
    jQuery('.faqs-model .jumplinks ul').remove();
  }

  let isScrolling = false;

  jQuery('.jumplinks ul li a').on('click', function (e) {
    e.preventDefault();
    var targetElement = jQuery(this.hash);

    if (targetElement.length) {
      isScrolling = true;
      var sTop = jQuery('header').outerHeight();

      var targetOffset = targetElement.offset()?.top;

      if (typeof targetOffset !== 'undefined') {
        jQuery('html,body').animate(
          { scrollTop: targetOffset - sTop },
          800,
          function () {
            isScrolling = false;
          }
        );
      }

      jQuery('.jumplinks ul li a').removeClass('active');
      jQuery('.jumplinks ul li').removeClass('active');
      jQuery(this).addClass('active');
      jQuery(this).parent().addClass('active');
    }
  });

  if (window.location.hash) {
    var targetElement = jQuery(window.location.hash);

    if (targetElement.length) {
      var sTop = jQuery('header').outerHeight();
      var targetOffset = targetElement.offset()?.top;

      if (typeof targetOffset !== 'undefined') {
        jQuery('html, body').animate({ scrollTop: targetOffset - sTop }, 800);
      }
    }
  }

  jQuery(window).on('scroll', function () {
    if (isScrolling) return;

    var sTop = jQuery('header').outerHeight();
    var scrollMiddle = jQuery(window).scrollTop() + (jQuery(window).height() / 3);
    var windowBottom = jQuery(window).scrollTop() + jQuery(window).height();
    var docHeight = jQuery(document).height();

    var activeId = null;
    var firstHeading = jQuery('h2').first();
    var lastHeading = jQuery('h2').last();

    jQuery('h2').each(function () {
      var section = jQuery(this);
      var sectionTop = section.offset()?.top;

      if (typeof sectionTop !== 'undefined' && scrollMiddle >= sectionTop) {
        activeId = section.attr('id');
      }
    });

    if (jQuery(window).scrollTop() === 0) {
      activeId = firstHeading.attr('id');
    }

    if (windowBottom >= docHeight - 10) {
      activeId = lastHeading.attr('id');
    }

    if (activeId) {
      jQuery('.jumplinks ul li a').removeClass('active');
      jQuery('.jumplinks ul li').removeClass('active');

      jQuery(`.jumplinks ul li a[href="#${activeId}"]`).addClass('active');
      jQuery(`#jumplink-${activeId}`).addClass('active');
    }
  });
}

function labelup() {
  jQuery(document).on("focus", "input[type=tel],input[type=email],input[type=text],textarea", function () {
    jQuery(this).siblings('label').addClass("active");
  });

  jQuery(document).on("blur change", "input[type=tel],input[type=email],input[type=text],textarea", function () {
    var isEmpty = !jQuery(this).val();
    jQuery(this).siblings('label').toggleClass("active", !isEmpty);
  });
}

function copy(copy_val) {
  const input = document.createElement('input');
  input.setAttribute('readonly', 'readonly');
  input.setAttribute('value', copy_val);
  document.body.appendChild(input);
  input.setSelectionRange(0, 9999);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}

function copyBtn() {
  let _this = this;
  jQuery('body').on('click', '.icon-Share', function (e) {
    e.preventDefault();
    if (!jQuery(this).hasClass('copied')) {
      let value = window.location.href;
      _this.copy(value);
      jQuery(this).addClass('copied');
      setTimeout(() => {
        jQuery(this).removeClass('copied');
      }, 1000);
    }
  })
}

function parallax() {
  if (jQuery(window).width() > 991) {
    var wh = jQuery(window).height();
    var sh = jQuery(window).scrollTop();

    jQuery(".parallax").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = 100 * (sh - (parallax_h - wh)) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });

    jQuery(".parallax-r").each(function () {
      var parallax_h = jQuery(this).offset().top;
      var item_h = jQuery(this).outerHeight();
      var parallax_y;
      if (sh > (parallax_h - wh) && sh < parallax_h + item_h) {
        parallax_y = (item_h / 10) * ((parallax_h - wh) - sh) / (wh + item_h);
      }
      jQuery(this).css('transform', 'translateY(' + parallax_y + '%)');
    });
  } else {
    jQuery('.parallax').css('transform', 'translateY(0)');
  }
}

function emailchecked() {
  $(document).ready(function () {
    $("footer .form-group input").on("keydown", function (e) {
      if (e.keyCode === 9) {
        e.preventDefault();
        $("footer .form-group button").focus();
      }
    });
  });
}

function selfsettingheightbox() {
  const lenis = new Lenis({
    inertia: 0.3,
  });

  function updateHeightVars() {
    try {
      const $stickyBar = $('.sticky-bar');
      const $header = $('.header');

      if ($stickyBar.length && $header.length) {
        const stickybarHeight = $stickyBar.outerHeight(true) || 0;
        const headerHeight = $header.outerHeight(true) || 0;
        document.documentElement.style.setProperty('--header-height', (stickybarHeight + headerHeight) + 'px');
      }

      const $mobilestickybar = $('.mobile-sticky-bar');
      const $paddingTopValue = parseInt($('.mobile-navbar-menu .content').css('padding-top')) || 0;

      if ($mobilestickybar.length && $paddingTopValue >= 0) {
        const mobilestickybar = $mobilestickybar.outerHeight(true) || 0;
        document.documentElement.style.setProperty('--mobilenavbarmenu', (mobilestickybar + $paddingTopValue) + 'px');
      }
    } catch (error) {
      console.error('Error updating height vars:', error);
    }
  }

  updateHeightVars();

  let tickingResize = false;
  $(window).on('resize', function () {
    if (!tickingResize) {
      window.requestAnimationFrame(function () {
        updateHeightVars();
        tickingResize = false;
      });
      tickingResize = true;
    }
  });

  function raf(time) {
    lenis.raf(time);
    updateHeightVars();
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
}

function arrowpadding() {
  var $rightContent = jQuery('.slider-banner .content .right-content');
  var $leftContent = jQuery('.slider-banner .content .left-content');
  var $nextArrow = jQuery('.slider-banner .content .right-content .media-box .slick-next');
  var $dots = jQuery('.slider-banner .content .right-content .media-box .slick-dots');

  var rightContentWidth = $rightContent.length ? $rightContent.width() : 0;
  var leftContentPadding = $leftContent.length ? parseInt($leftContent.css('padding-right'), 10) || 0 : 0;
  var nextArrowWidth = $nextArrow.length ? $nextArrow.width() : 0;
  var dotsWidth = $dots.length ? $dots.width() : 0;

  if (jQuery(window).width() >= 992) {
    var base = rightContentWidth + leftContentPadding;

    if (base > 0) {
      document.documentElement.style.setProperty('--sliderrightarrow', base + 'px');
    }
    if (nextArrowWidth > 0) {
      document.documentElement.style.setProperty('--sliderdotsarrow', (base + nextArrowWidth + 8) + 'px');
    }
    if (nextArrowWidth > 0 && dotsWidth > 0) {
      document.documentElement.style.setProperty('--sliderleftarrow', (base + nextArrowWidth + dotsWidth + 16) + 'px');
    }
  } else {
    var mobilebase = leftContentPadding;

    if (mobilebase > 0) {
      document.documentElement.style.setProperty('--sliderrightarrow', (mobilebase + 0) + 'px');
    }
    if (nextArrowWidth > 0) {
      document.documentElement.style.setProperty('--sliderdotsarrow', (mobilebase + nextArrowWidth + 8) + 'px');
    }
    if (nextArrowWidth > 0 && dotsWidth > 0) {
      document.documentElement.style.setProperty('--sliderleftarrow', (mobilebase + nextArrowWidth + dotsWidth + 16) + 'px');
    }
  }
}

function clicksize() {
  jQuery("body").on("click", ".product-item .btn-box p", function () {
    var $this = jQuery(this);
    var $currentProductItem = $this.closest(".product-item");

    $this.toggleClass("active")
      .closest(".product-item")
      .find(".btn-box p")
      .not(this)
      .removeClass("active");
  });
}

function changeimgcol() {
  jQuery("body").on("click", ".filter-mobile-show .right-box span", function () {
    jQuery(this).addClass("active").siblings().removeClass("active");

    if (jQuery(this).hasClass("icon-tiled")) {
      jQuery(".filter-content-bottom").addClass("active");
    } else {
      jQuery(".filter-content-bottom").removeClass("active");
    }
  });
}

function filterpopbox() {
  $('body').on('click', '.filter-mobile-show .left-box', function (e) {
    e.stopPropagation();
    $('.mobile-filter-control').addClass('active');
    $("html").addClass("overflow-hidden");
    $("html, body").attr("data-lenis-prevent", "true");
  });

  $('body').on('click', '.filter-blog-model .mobile-filter-control.active .filter-control-box', function (e) {
    e.stopPropagation();
  });

  $('body').on('click', '.filter-blog-model .mobile-filter-control .title-box .icon-close', function (e) {
    $("html").removeClass("overflow-hidden");
    $('.mobile-filter-control').removeClass('active');
    $("html, body").removeAttr("data-lenis-prevent", "true");
  });


  $('body').on('click', '.filter-blog-model .facets-toggle .facets-toggle__wrapper button', function (e) {
    e.stopPropagation();
    $('.mobile-filter-control').addClass('active');
    $("html").addClass("overflow-hidden");
    $("html, body").attr("data-lenis-prevent", "true");
  });


  $('body').on('click', function (e) {
    if ($('.mobile-filter-control').hasClass('active')) {
      if (!$(e.target).closest('.filter-control-box').length) {
        $("html").removeClass("overflow-hidden");
        $('.mobile-filter-control').removeClass('active');
        $("html, body").removeAttr("data-lenis-prevent", "true");
      }
    }
  });

}

function isEmail(email) {
  var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
  if (reg.test(email)) {
    return true;
  } else {
    return false;
  }
}

function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();